import type { Ref } from '@/composition/vue/compositionApi'
import { computed } from '@/composition/vue/compositionApi'
import type { AnyTemplateElement } from '@/components/types'

export const useHtmlElementFromTemplateRef = <T extends AnyTemplateElement | null | undefined>(ref: Ref<T>) => {
  return computed(() => {
    const rawElement = ref.value
    if (rawElement && typeof rawElement === 'object' && '$el' in rawElement) {
      return rawElement.$el as HTMLElement
    }
    return (rawElement as HTMLElement) || null
  })
}
